<template>
	<div class="torir-spectrogram-controller">
		<div class="--basic">
			<input
				v-model="zoom"
				type="range"
				min="-1"
				max="1"
				step="0.01"
			>
			<button
				@click="detailsVisible = !detailsVisible"
			>
				設定
			</button>
		</div>
		<div
			v-if="detailsVisible"
			class="--details"
		>
			<!--
			<FormGroup
				label="カラーマップ"
				:fit="true"
			>
				<select
					ref="firstInput"
					v-model="colorMapName"
				>
					<option
						v-for="colorMap in spectrogram.colorMaps"
						:key="colorMap.name"
						:value="colorMap.name"
					>
						{{ colorMap.name }}
					</option>
				</select>
			</FormGroup>
			-->
			<FormGroup
				label="値域"
				:fit="true"
			>
				<input
					v-model="decibelMin"
					type="number"
					size="1"
					min="-120"
					max="100"
				>
				<span class="--dash-range">–</span>
				<input
					v-model="decibelMax"
					type="number"
					size="1"
					min="-100"
					max="120"
				>
				<span class="unit">dB</span>
			</FormGroup>
			<FormGroup
				label="ブースト"
				:fit="true"
			>
				<input
					v-model="decibelBoost"
					type="number"
					size="1"
					min="-120"
					max="120"
				>
				<span class="--unit">dB /&nbsp;</span>
				<input
					v-model="ratioBoost"
					type="number"
					size="1"
					min="1"
					max="10"
				>
				<span class="--unit"> ×</span>
			</FormGroup>
			<FormGroup
				label="クリップ"
				:fit="true"
			>
				<input
					v-model="decibelClip"
					type="number"
					size="1"
					min="-120"
					max="120"
				>
				<span class="--unit">dB /&nbsp;</span>
				<input
					v-model="ratioClip"
					type="number"
					size="1"
					min="1"
					max="10"
				>
				<span class="--unit"> ×</span>
			</FormGroup>
			<FormGroup
				label="表示高さ"
				:fit="true"
			>
				<input
					v-model="height"
					type="number"
					size="1"
					min="60"
					max="1000"
				>
				<span class="--unit">px</span>
				<span class="--space" />
			</FormGroup>
			<FormGroup
				label="表示周波数"
				:fit="true"
			>
				<input
					v-model="freqMin"
					type="number"
					size="1"
					min="0"
					:max="nyquist"
				>
				<span class="--dash-range">–</span>
				<input
					v-model="freqMax"
					type="number"
					size="1"
					min="0"
					:max="nyquist"
				>
				<span class="--unit">Hz</span>
			</FormGroup>
			<FormGroup label="周波数解像度">
				<input
					v-model="fftsDegree"
					type="range"
					min="6"
					max="14"
					step="1"
				>
				<div class="--note">
					FFT samples = {{ fftSamples }}
				</div>
			</FormGroup>
			<div class="--action">
				<button
					type="button"
					@click="apply"
				>
					適用
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import FormGroup from './FormGroup.vue'

export default {
	name: 'TorirSpectrogramController',
	components: {
		FormGroup
	},
	props: {
		spectrogram: {
			type: Object,
			required: true
		},
		options: {
			type: Object,
			default: () => ({})
		}
	},
	data () {
		const { spectrogram } = this
		return {
			zoom: Math.log10(this.spectrogram.zoom),
			colorMapName: spectrogram.colorMapName,
			decibelMin: spectrogram.valueRange.decibelMin,
			decibelMax: spectrogram.valueRange.decibelMax,
			decibelBoost: spectrogram.valueRange.decibelBoost,
			ratioBoost: spectrogram.valueRange.ratioBoost,
			decibelClip: spectrogram.valueRange.decibelClip,
			ratioClip: spectrogram.valueRange.ratioClip,
			fftsDegree: Math.min(14, Math.max(6, Math.floor(Math.log2(spectrogram.fftSamples)))),
			freqMin: spectrogram.freqMin,
			freqMax: spectrogram.freqMax,
			height: spectrogram.height,
			detailsVisible: false
		}
	},
	computed: {
		fftSamples () {
			return Math.pow(2, this.fftsDegree)
		},
		nyquist () {
			return this.spectrogram.freqSampling / 2
		}
	},
	watch: {
		zoom () {
			this.spectrogram.zoom(Math.pow(10, this.zoom))
		}
		/*
		colorMapName () {
			this.spectrogram.setColorMap(this.colorMapName)
		},
		decibelMin () {
			this.updateValueRange()
		},
		decibelMax () {
			this.updateValueRange()
		},
		decibelBoost () {
			this.updateValueRange()
		},
		ratioBoost () {
			this.updateValueRange()
		},
		decibelClip () {
			this.updateValueRange()
		},
		ratioClip () {
			this.updateValueRange()
		},
		fftsDegree () {
			this.spectrogram.setFftSamples(this.fftSamples)
		},
		freqMin () {
			this.spectrogram.setFrequencyRange(this.freqMin, this.freqMax)
		},
		freqMax () {
			this.spectrogram.setFrequencyRange(this.freqMin, this.freqMax)
		},
		height () {
			this.spectrogram.setHeight(parseInt(this.height, 10))
		}
		*/
	},
	methods: {
		updateValueRange () {
			this.spectrogram.setValueRange({
				decibelMin: parseFloat(this.decibelMin),
				decibelMax: parseFloat(this.decibelMax),
				decibelBoost: parseFloat(this.decibelBoost),
				ratioBoost: parseFloat(this.ratioBoost),
				decibelClip: parseFloat(this.decibelClip),
				ratioClip: parseFloat(this.ratioClip)
			})
		},
		apply () {
			this.spectrogram.setColorMap(this.colorMapName)
			this.updateValueRange()
			this.spectrogram.setFftSamples(this.fftSamples)
			this.spectrogram.setFrequencyRange(this.freqMin, this.freqMax)
			this.spectrogram.setHeight(parseInt(this.height, 10))
		}
	}
}
</script>

<style lang="scss" scoped>
.torir-spectrogram-controller {
	align-items: center;
	padding: .25em;
	color: #333;
	background: #eee;
}
.--basic {
	display: flex;
	justify-content: space-between;
}
.--details {
	margin: 5px auto;
	max-width: 445px;
}
.--action {
	text-align: right;
}
</style>
